import { type FC, type ReactNode } from "react";

import { Button } from "@/shared/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipInfoTrigger,
  TooltipProvider,
} from "@/shared/components/ui/tooltip";

interface ModalStepLayoutProps {
  sidebar?: ReactNode;
  title: string;
  titleTooltip?: { title?: string; content: string };
  description?: string;
  onBack?: () => void;
  footerLeft?: ReactNode;
  actionButton?: ReactNode;
  afterContent?: ReactNode;
  children: ReactNode;
}

export const ModalStepLayout: FC<ModalStepLayoutProps> = ({
  sidebar,
  title,
  titleTooltip,
  description,
  onBack,
  footerLeft,
  actionButton,
  afterContent,
  children,
}) => (
  <div className="flex h-full">
    {sidebar}

    <div className="flex min-w-0 flex-1 flex-col bg-subtle">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto p-4 sm:p-6">
        <div className="flex w-full flex-1 flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h4>
              {title}
              {titleTooltip && (
                <TooltipProvider>
                  <Tooltip>
                    <TooltipInfoTrigger
                      aria-label={titleTooltip.title}
                      className="ml-1.5 align-middle"
                    />
                    <TooltipContent title={titleTooltip.title}>
                      {titleTooltip.content}
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              )}
            </h4>
            {description && <p className="text-sm text-secondary">{description}</p>}
          </div>

          {children}

          {afterContent}
        </div>
      </div>

      <div className="flex shrink-0 items-center justify-between border-t border-primary px-4 py-4 sm:px-6">
        {onBack ? (
          <Button variant="outline" size="md" onClick={onBack}>
            Back
          </Button>
        ) : (
          (footerLeft ?? <div />)
        )}
        {actionButton}
      </div>
    </div>
  </div>
);
